import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const TermsOfUse = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Use - Ganda Sushi</title>
      </Helmet>

      <main className="bg-luxury-cream text-luxury-dark pt-40 pb-24">
        <section className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="prose prose-gold max-w-none"
          >
            <h1 className="text-5xl font-serif text-luxury-gold mb-12 uppercase tracking-tight">Terms of Use</h1>
            <p className="text-luxury-dark/60 italic mb-12 border-l-2 border-luxury-gold pl-6">Effective Date: January 27, 2025</p>

            <div className="space-y-12 text-luxury-dark/70 leading-relaxed font-light">
              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">1. Agreement</h2>
                <p>
                  By engaging with Ganda Sushi's services, you agree to abide by our professional standards and policies. We strive to provide an exceptional experience for all our patrons.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">2. Dining Experience</h2>
                <p>
                  We reserve the right to curate our dining environment to ensure the comfort and enjoyment of all guests. This includes adhering to our reservation policies and behavioral expectations.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">3. Intellectual Property</h2>
                <p>
                  All culinary designs, branding, and digital content are the exclusive property of Ganda Sushi. Unauthorized reproduction of our proprietary recipes or visual assets is strictly prohibited.
                </p>
              </section>
            </div>
          </motion.div>
        </section>
      </main>
    </>
  );
};

export default TermsOfUse;